import { useState } from 'react';
import { resetFields } from '@/constants/FormFields';
import Button from '@/components/Button';
import Input from '@/components/Input';
import { routes } from '@/constants/routes';
import { toast } from 'react-toastify';

const ResetPassword = () => {
	const [loginState, setLoginState] = useState({
		email: '',
	});

	const handleChange = (e) => {
		setLoginState({ ...loginState, [e.target.id]: e.target.value });
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		await resetPasswordUser();
	};

	const resetPasswordUser = async () => {
		try {
			await axios.post(`${import.meta.env.VITE_API_URL}/api/reset-password`, loginState);

			toast.success('Email de réinitialisation envoyé', {
				position: 'top-center',
				autoClose: 800,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			setTimeout(() => navigate(routes.home), 1000);
		} catch (error) {
			toast.error('Une erreur est survenue', {
				position: 'top-center',
				autoClose: 800,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: false,
				draggable: true,
				theme: 'colored',
			});

			// We refresh the page
			setTimeout(() => navigate('/login'), 1000);
		}
	};

	return (
		<form className="mt-8 space-y-6" onSubmit={handleSubmit}>
			<div className="-space-y-px">
				{resetFields.map((field) => (
					<Input
						key={field.id}
						handleChange={handleChange}
						value={loginState[field.id]}
						labelText={field.labelText}
						labelFor={field.labelFor}
						id={field.id}
						name={field.name}
						type={field.type}
						isRequired={field.isRequired}
						placeholder={field.placeholder}
						fullWidthInput={true}
					/>
				))}
			</div>

			<Button
				handleSubmit={handleSubmit}
				text="Mot de passe oublié"
				disabled={loginState.email !== '' && /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(loginState.email)}
			/>
		</form>
	);
};

export default ResetPassword;
